import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import Container from '../BoxedContainer'

export const Banner = styled.div<{ $isSearchPage?: boolean }>`
  background-color: ${({ $isSearchPage, theme }) =>
    $isSearchPage ? theme.colors.brownBack : theme.colors.blueBack};
`

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1.8rem;

  @media ${mq(sizes.tablet)} {
    gap: 2rem;
    padding: 3rem 0 !important;
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0;

  @media ${mq(null, sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSansLgBold};
  }
`

export const Text = styled.div`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: ${({ theme }) => theme.colors.bluePrimary};
  text-align: center;
`

export const Button = styled(ActionButton)``
